<template>
  <div>
    <CCardBody class="py-0 pl-0 pr-0">
      <table class="table mb-0">
        <thead v-show="false">
          <tr>
            <th scope="col">name</th>
            <th v-if="tabla!==3" scope="col">labor</th>
            <th v-if="tabla!==3" scope="col">producto</th>
            <th v-if="tabla!==3" scope="col">gasto</th>
            <th scope="col">total</th>
            <th scope="col">plantas</th>
            <th scope="col">produccion</th>
          </tr>
        </thead>

        <tbody
          v-for="(r, index) in ubicaciones.filter(
            ubi => ubi.payload.pertenece_id == ubicacionPadre
          )"
          :key="index"
        >
          <tr class="d-table-row pl-2">
            <td
              @click="toggleSubUbicaciones(index)"
              :class="
                `${
                  ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                    .length > 0
                    ? `cursor-p`
                    : ``
                }`
              "
              class="custom-width-name-prodc sp-pd"
            >
              <span>
                <CIcon
                  v-if="
                    ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                      .length > 0
                  "
                  name="cil-chevron-circle-down-alt"
                />
              </span>
              {{ r.payload.nombre }}
            </td>
            <td v-if="tabla!==3"
              @click="toggleSubUbicaciones(index)"
              class="custom-width-name-prodc sp-pd"
              :class="
                `${
                  ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                    .length > 0
                    ? `cursor-p`
                    : ``
                }`
              "
            >
              {{ r.labor}}
            </td>
            <td v-if="tabla!==3"
              @click="toggleSubUbicaciones(index)"
              class="custom-width-name-prodc sp-pd"
              :class="
                `${
                  ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                    .length > 0
                    ? `cursor-p`
                    : ``
                }`
              "
            >
              {{ r.productos}}
            </td>

            <td v-if="tabla!==3" 
              @click="toggleSubUbicaciones(index)"
              class="custom-width-name-prodc sp-pd"
              :class="
                `${
                  ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                    .length > 0
                    ? `cursor-p`
                    : ``
                }`
              "
            >
              {{ r.gastos}}
            </td>
            <td
              @click="toggleSubUbicaciones(index)"
              class="custom-width-name-prodc sp-pd"
              :class="
                `${
                  ubicaciones.filter(u => u.payload.pertenece_id == r.id)
                    .length > 0
                    ? `cursor-p`
                    : ``
                }`
              "
            >
              {{ r.total}}
            </td>
            <!-- <td v-if="tabla == 3" class="custom-width-name-prodc sp-pd">{{ r.payload.cantidad_plantas ? r.payload.cantidad_plantas : 0 }}</td> -->
            <td v-if="tabla == 3" class="custom-width-name-prodc sp-pd">{{ $formatter(getPlantas(r),false,'.00') }}</td>
            <td v-if="tabla == 3" class="custom-width-name-prodc sp-pd">{{ produccionPlanta(r) }}</td>
          </tr>
          <tr
            v-if="
              ubicaciones.filter(p => p.payload.pertenece_id == r.id).length > 0
            "
          >
            <td class="py-0 pl-2 pr-0" :colspan="tabla == 3 ? '7' : '5'">
              <CCollapse
                :show="subDetails.includes(index)"
                class="m-0 custom-width-total"
              >
                <table-collapse
                  @click-cancel="toggleCancel"
                  @click-print="printNanoid"
                  :ubicacionPadre="r.id"
                  :cultivos="cultivos"
                  :ubicaciones="ubicaciones"
                  :tabla="tabla"
                ></table-collapse>
              </CCollapse>
            </td>
          </tr>
        </tbody>
      </table>
    </CCardBody>
  </div>
</template>

<script>
export default {
  name: "TableCollapseAnalisis",

  props: {
    ubicaciones: {
      type: Array
    },
    cultivos: {
      type: Array
    },
    ubicacionPadre: {
      type: Number
    },
    tabla: {
      type: Number
    }
  },

  data() {
    return {
      subDetails: [],
      itemModal: { id: "", name: "", index: "" }
    };
  },

  components: {
    TableCollapse: () => import("./TableCollapseAnalisis.vue")
  },

  methods: {
    getPlantas(id) {
      let cant = 0
      let ubis = []
      for (let index = 0; index < this.ubicaciones.length; index++) {
        const element = this.ubicaciones[index];
        const ubi = element.payload.ruta.slice(1,-1).split('/')
        if (ubi.find(el => el == id.id)) {
          if (element.payload.cantidad_plantas) {
            ubis.push(element.payload.cantidad_plantas)
            cant += element.payload.cantidad_plantas
          }
        }
        
      }
      return cant
    },
    produccionPlanta(id) {
      let cant = 0
      let ubis = []
      for (let index = 0; index < this.ubicaciones.length; index++) {
        const element = this.ubicaciones[index];
        const ubi = element.payload.ruta.slice(1,-1).split('/')
        if (ubi.find(el => el == id.id)) {
          if (element.payload.cantidad_plantas) {
            ubis.push(element.payload.cantidad_plantas)
            cant += element.payload.cantidad_plantas
          }
        }
        
      }
      if (id.total == 0) {
        return 0
      }else if(cant == 0){
        return 0
      }else{
        return ( id.total / cant ).toFixed(3)
      }
      
      // let cant = r.payload.cantidad_plantas ? r.payload.cantidad_plantas : 0
      
    },
    toggleCancel(index, item) {
      this.$emit("click-cancel", index, item);
    },
    printNanoid(ubicacion) {
      this.$emit("click-print", ubicacion);
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },

    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivos.find(
        cultivo => cultivo.id == cultivo_id
      );

      return cultivoActual ? cultivoActual.payload.nombre : "";
    },
    toggleSubUbicaciones(index) {
      const positionSub = this.subDetails.indexOf(index);
      positionSub !== -1
        ? this.subDetails.splice(positionSub, 1)
        : this.subDetails.push(index);
    }
  }
};
</script>

<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.sp-pd {
  padding-left: 12px;
  padding-right: 12px;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width-name {
  width: 20% !important;
}
.custom-width-name-prodc {
  width: 15% !important;
}
.custom-width {
  width: 17%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100% !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
